export const siteStorageName = "crunchorder";
export const authName = "bodenhoffAuth";
export const chosenDateName = "bodenhoffChosenDate";
export const productionFacilityName = "bodenhoffProductionFacility";